// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "pre[data-v-3cd782de]{font-family:Vazir,sans-serif!important}", ""]);
// Exports
module.exports = exports;
